import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPlot } from '../api/sitesApi.ts';
import type { CreatePlotRequest } from '../api/sitesApi.ts';
import { plotsKeys } from './usePlotsQuery.ts';

/**
 * Mutation hook for creating plots.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useCreatePlot = (siteId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePlotRequest) => createPlot(siteId, data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: plotsKeys.lists(),
      });
    },
  });
};
